const selectOnlineOrderingLocationId = state =>
  state.cart?.online_ordering_location ?? '';

export default selectOnlineOrderingLocationId;
